<template>
	<div v-if="goodsInfo" class="goods-option-container">
		<div class="goods-option-head">
			<div class="img">
				<img :src="goodsInfo['product_img']" />
			</div>
			<div class="right">
				<div class="title">{{ goodsInfo["product_name"] }}</div>
				<p class="text-ellipsis-row2">{{ goodsOptionText }}</p>
			</div>
			<img class="close-img" src="~@/assets/title_icon_close_black.png" @click="close" />
		</div>

		<div class="goods-option-main">
			<!-- 数量 -->
			<div class="goods-option-box number-row">
				<div class="title">数量</div>
				<stepper v-model="formData.qty" disable-input />
			</div>

			<template v-for="group in groupedTree">
				<div :key="group.parent.code" :class="group.children.length > 0 ? 'goods-option-group' : ''">
					<component class="goods-option-box" :rules="getRules(group.parent)" :data="group.parent"
						:is="group.parent.components" :value="extra[group.parent._idx]"
						@input="onExtraInput(group.parent._idx, $event)" />
					<component v-for="child in group.children" :key="child.code + child._idx" class="goods-option-box"
						:class="child._depth === 1 ? 'goods-option-child' : 'goods-option-grandchild'"
						:rules="getRules(child)" :data="child" :is="child.components" :value="extra[child._idx]"
						@input="onExtraInput(child._idx, $event)" />
				</div>
			</template>
		</div>

		<div class="goods-option-foot">
			<button class="right-btn" @click="add">添加至购物车 {{ money }}</button>
		</div>
	</div>
</template>

<script>
	import {
		stepper
	} from "vant";
	import selectComponent from "./selectOption";
	import pageevent from "../event";
	import type1 from "./type1";
	import type2 from "./type2";
	import type3 from "./type3";

	export default {
		props: ['goodsInfo', 'goodsDtl'],
		data() {
			return {
				extra: [],
				formData: {
					id: null,
					sku: null,
					qty: 1,
				},
			};
		},
		created() {
			var cd = this.goodsDtl['customization_data'] || {};
			var custList = cd['customizations'] || [];
			console.log('customizations count:', custList.length);
			console.log('default_spec_sku:', cd['default_spec_sku']);
			console.log('has rules:', !!(this.goodsDtl['rules'] || []).length);
			var skuId = cd['default_spec_sku'];
			var rulesSet = (this.goodsDtl['rules'] || []).find(function(d) { return d['code'] == skuId; });
			if (rulesSet) {
				var custCodes = {};
				custList.forEach(function(c) { custCodes[c['code']] = true; });
				rulesSet['rules'].forEach(function(r) {
					console.log('rule:', r.group_code, r.group_name, 'must:', r.must, 'hide:', r.hide, 'in_cust:', !!custCodes[r.group_code]);
				});
			}
			// 打印 ChangeCup 的 customizations 条目
			var cupItem = custList.find(function(c) { return c['code'] === 'ChangeCup'; });
			console.log('ChangeCup in customizations:', cupItem ? JSON.stringify(cupItem) : 'NOT FOUND');
			this._injectMissingRules(cd);
			console.log('after inject:', (cd['customizations'] || []).length);
			this.extra = new Array((cd['customizations'] || []).length).fill({});

			var mapping = this.goodsDtl['coffee_sku_mapping'] || {};
			var keys = Object.keys(mapping);
			var first = keys.length > 0 ? mapping[keys[0]] : {};
			this.formData.id = cd.id || first.id || '';
			this.formData.sku = cd.sku || first.sku_id || '';

			this.initDefaults();
		},
		methods: {
			_injectMissingRules(cd) {
				var customizations = cd['customizations'];
				if (!customizations || !Array.isArray(customizations)) return;

				var skuId = cd['default_spec_sku'];
				if (!skuId) return;

				var rulesSet = (this.goodsDtl['rules'] || []).find(function(d) {
					return d['code'] == skuId;
				});
				if (!rulesSet) return;

				var rules = rulesSet['rules'];
				var custCodes = {};
				for (var ci = 0; ci < customizations.length; ci++) {
					custCodes[customizations[ci]['code']] = true;
				}

				for (var i = 0; i < rules.length; i++) {
					var rule = rules[i];
					if (rule.hide === 1) continue;
					if (rule.must !== 1) continue;
					if (custCodes[rule['group_code']]) continue;

					var details = rule['group_detail_rules'] || [];
					var visibleDetails = [];
					for (var j = 0; j < details.length; j++) {
						if (details[j].hide !== 1) visibleDetails.push(details[j]);
					}
					if (visibleDetails.length === 0) continue;

					var extraList = [];
					for (var k = 0; k < visibleDetails.length; k++) {
						var d = visibleDetails[k];
						extraList.push({
							code: d['group_detail_code'],
							extra_sku: d['group_detail_code'],
							name: d['name'],
							is_default: d['is_default'] || 0,
							must: d['must'] || 0,
							price: 0,
							hide: 0,
							sequence: d['sequence'] || 0,
							max_number: d['max_number'],
							min_number: d['min_number'],
							default_count: d['default_count']
						});
					}

					var newItem = {
						code: rule['group_code'],
						name: rule['group_name'],
						display_type: 'text',
						must: rule['must'],
						hide: 0,
						sequence: rule['sequence'] || 0,
						extra_list: extraList
					};

					// 插入到"杯型"后面，没有则追加到末尾
					var cupsizeIdx = -1;
					for (var ci2 = 0; ci2 < customizations.length; ci2++) {
						if (customizations[ci2]['code'] === 'Cupsize') {
							cupsizeIdx = ci2;
							break;
						}
					}
					if (cupsizeIdx >= 0) {
						customizations.splice(cupsizeIdx + 1, 0, newItem);
					} else {
						customizations.push(newItem);
					}
				}
			},
			initDefaults() {
				this._initTreeDefaults(this.renderTree);
			},
			_initTreeDefaults(nodes, processed, forceDefaults) {
				if (!processed) processed = {};
				for (var i = 0; i < nodes.length; i++) {
					var item = nodes[i];
					if (processed[item._idx]) continue;
					processed[item._idx] = true;
					if (this.extra[item._idx] && this.extra[item._idx].extra_sku) {
						if (item._children && item._children.length > 0) {
							this._initTreeDefaults(item._children, processed);
						}
						continue;
					}

					var extras = item.extra_list;
					if (!extras || extras.length === 0) continue;

					// type3 (bar) 类型：用 rules 的 default_count 作为默认份数
					if (item.components === 'type3') {
						var rules = this.getRules(item);
						var rulesDtl = rules && rules['group_detail_rules'];
						var valList = [];
						for (var k = 0; k < extras.length; k++) {
							var extra = extras[k];
							var ruleItem = null;
							if (rulesDtl) {
								ruleItem = rulesDtl.find(function(r) {
									return r['group_detail_code'] === (extra['extra_sku'] || extra['code']);
								}) || null;
							}
							var ruleDef = ruleItem && ruleItem['default_count'];
							var origDef = extra['default_count'];
							var defCount = ruleDef !== undefined ? ruleDef : (origDef !== undefined ? origDef : 1);
							var _min = (ruleItem && ruleItem['min_number'] !== undefined) ? ruleItem['min_number'] : (
								extra['min_number'] || 0);
							var _max = (ruleItem && ruleItem['max_number'] !== undefined) ? ruleItem['max_number'] : (
								extra['max_number'] || 99);
							var qty = 0;
							// 当 forceDefaults=true（切换萃取方式场景），强制使用 default_count
							if (forceDefaults && defCount !== undefined && defCount > 0) {
								qty = Math.max(_min, Math.min(_max, defCount));
							} else if (extra.must === 1 || extra.is_default === 1) {
								qty = Math.max(_min, Math.min(_max, defCount));
							}
							// must === 0 且 is_default === 0 时 qty 保持 0，用户勾选后才填入 default_count
							// price 设为 0，由 type3.vue 的 loadMoney() 在 rules 合并后重新计算
							valList.push({
								title: item.name,
								id: extra.id,
								name: extra.name,
								price: 0,
								extra_sku: extra.extra_sku || extra.code,
								attribute: extra.attribute,
								parent_code: item.code,
								qty: qty
							});
						}

						this.$set(this.extra, item._idx, valList);
						if (item._children && item._children.length > 0) {
							this._initTreeDefaults(item._children, processed);
						}
						continue;
					}

					var defItem = null;
					if (item.components === 'type2') {
						// type2 (bool): must=1 或 is_default=1 时预选
						defItem = extras.find(function(d) {
							return d.must === 1 || d.is_default === 1;
						});
					} else {
						defItem = extras.find(function(d) {
							return d.is_default === 1;
						});
						if (!defItem && item.name === '浓缩咖啡') defItem = extras.find(function(d) {
							return d.name === '标准';
						});
						if (!defItem && item.name === '萃取方式' && extras.length > 0) defItem = extras[0];
					}
					if (!defItem) continue;

					// type2 (bool) 使用 rules 的 default_count 作为勾选后的份数
					var _qty = 1;
					if (item.components === 'type2') {
						var _rules = this.getRules(item);
						var _rulesDtl = _rules && _rules['group_detail_rules'];
						if (_rulesDtl && Array.isArray(_rulesDtl)) {
							var _code = defItem.extra_sku || defItem.code;
							var _ruleItem = _rulesDtl.find(function(r) {
								return r['group_detail_code'] === _code;
							});
							if (_ruleItem) {
								if (_ruleItem['default_count'] !== undefined) {
									_qty = _ruleItem['default_count'];
								} else if (_ruleItem['min_number'] !== undefined) {
									_qty = _ruleItem['min_number'];
								}
							}
						}
					}

					this.$set(this.extra, item._idx, {
						title: item.name,
						id: defItem.id,
						name: defItem.name,
						price: Number(defItem.price) || 0,
						extra_sku: defItem.extra_sku || defItem.code,
						attribute: defItem.attribute,
						parent_code: item.code,
						qty: _qty > 0 ? _qty : 1
					});

					if (item._children && item._children.length > 0) {
						this._initTreeDefaults(item._children, processed);
					}
				}
			},
			onExtraInput(idx, val) {
				var oldVal = this.extra[idx];
				this.$set(this.extra, idx, val);
				this._resetChildrenCascade(idx, oldVal);
			},
			_resetChildrenCascade(parentIdx, oldVal) {
				var list = this.flatList;
				var item = list[parentIdx];
				if (!item) return;
				var currentVal = this.extra[parentIdx];
				var newCode = currentVal && currentVal['extra_sku'];
				var oldCode = oldVal && oldVal['extra_sku'];
				// 重置旧父级的子项（变体切换时）
				if (oldCode && oldCode !== newCode) {
					this._resetChildrenByCode(list, oldCode);
				}
				// 重置新父级的子项并重新初始化默认值
				if (newCode) {
					this._initChildrenDefaults(item);
				}
			},
			/**
			 * 重新初始化指定父级下所有子项的默认值
			 */
			_initChildrenDefaults(parentItem) {
				// 递归搜索整棵树找到对应节点
				function findInTree(nodes) {
					for (var i = 0; i < nodes.length; i++) {
						if (nodes[i].code === parentItem.code) return nodes[i];
						if (nodes[i]._children && nodes[i]._children.length > 0) {
							var found = findInTree(nodes[i]._children);
							if (found) return found;
						}
					}
					return null;
				}
				var fresh = findInTree(this.renderTree);
				if (fresh && fresh._children && fresh._children.length > 0) {
					var currentVal = this.extra[parentItem._idx];
					var selectedCode = currentVal && currentVal['extra_sku'];
					// 找到 code === selectedCode 的子项（属于当前选中变体的子项）
					// 或者找到 parent_category_code === parentItem.code 的子项（当前父级的直接子项）
					var childrenToInit = [];
					for (var ci2 = 0; ci2 < fresh._children.length; ci2++) {
						var child = fresh._children[ci2];
						// 匹配条件：子项的 code 等于选中变体的 extra_sku
						if (child.code === selectedCode) {
							childrenToInit.push(child);
							// 同时初始化这些子项的所有孙子项
							if (child._children && child._children.length > 0) {
								for (var ci3 = 0; ci3 < child._children.length; ci3++) {
									childrenToInit.push(child._children[ci3]);
								}
							}
						}
					}
					if (childrenToInit.length > 0) {
						this._initTreeDefaults(childrenToInit, {}, true);
					}
				}
			},
			_resetChildrenByCode(list, parentCode) {
				for (var j = 0; j < list.length; j++) {
					if (list[j]['parent_category_code'] === parentCode) {
						this.$set(this.extra, j, {});
					}
				}
			},
			getRules(item) {
				var skuId = null;
				if (this.coffeeMapping) {
					skuId = this.coffeeMapping['sku_id'];
				} else {
					var cd = this.goodsDtl['customization_data'] || {};

					skuId = cd['default_spec_sku'];
				}
				if (!skuId) return null;
				var rulesSet = (this.goodsDtl['rules'] || []).find(function(d) {
					return d['code'] == skuId;
				});
				if (!rulesSet) return null;
				var rules = rulesSet['rules'];
				var list = this.flatList;

				// 1) Direct match: group_name + group_code == item.code
				var found = rules.find(function(d) {
					return d['group_name'] == item['name'] && d['group_code'] == item['code'];
				});
				if (found) return found;

				if (!item['parent_category_code']) return null;

				// 2) Walk up parent chain — check if any ancestor's code matches a rule's group_code
				var parentCode = item['parent_category_code'];
				var depth = 0;
				while (parentCode && depth < 5) {
					var parentItem = list.find(function(d) {
						return d['code'] === parentCode;
					});
					if (!parentItem) break;
					var match = rules.find(function(d) {
						return d['group_name'] == item['name'] && d['group_code'] == parentItem['code'];
					});
					if (match) return match;
					parentCode = parentItem['parent_category_code'];
					depth++;
				}

				// 3) Sibling search: for items like 浓缩份数 where rules are keyed by
				//    a sibling container's children (e.g. 710006934's children AddGuateAntEspresso)
				parentCode = item['parent_category_code'];
				var parentItem2 = list.find(function(d) {
					return d['code'] === parentCode;
				});
				if (parentItem2) {
					var gpCode = parentItem2['parent_category_code'];
					if (gpCode) {
						var siblings = list.filter(function(d) {
							return d['parent_category_code'] === gpCode && d['code'] !== parentCode;
						});
						for (var si = 0; si < siblings.length; si++) {
							var sibChildren = list.filter(function(d) {
								return d['parent_category_code'] === siblings[si]['code'];
							});
							for (var sci = 0; sci < sibChildren.length; sci++) {
								var sibMatch = rules.find(function(d) {
									return d['group_name'] == item['name'] && d['group_code'] == sibChildren[sci][
										'code'
									];
								});
								if (sibMatch) return sibMatch;
							}
						}
					}
				}

				return null;
			},
			close() {
				this.$emit('close');
			},
			add() {
				var _data = Object.assign({}, this.formData);
				var _extra = [];
				var vis = this.visibleIndices;

				// 收集 coffee_sku_mapping key 的独立部分，用于识别变体选择器的选项
				var mappingKeys = Object.keys(this.goodsDtl['coffee_sku_mapping'] || {});
				var mappingParts = {};
				for (var mk = 0; mk < mappingKeys.length; mk++) {
					var parts = mappingKeys[mk].split('_');
					for (var mp = 0; mp < parts.length; mp++) {
						mappingParts[parts[mp]] = true;
					}
				}

				for (var fi = 0; fi < this.extra.length; fi++) {
					if (!vis[fi]) continue;
					var item = this.extra[fi];
					if (!item) continue;
					var items = Array.isArray(item) ? item : [item];
					for (var ai = 0; ai < items.length; ai++) {
						var e = items[ai];
						if (e && e["id"] && e["qty"] != 0 && !mappingParts[e["extra_sku"]]) {
							_extra.push({
								extra_sku: e["extra_sku"],
								id: e["id"],
								qty: e["qty"],
							});
						}
					}
				}

				// id/sku 使用基础商品值，spec_id/spec_sku 使用规格值
				var cd = this.goodsDtl['customization_data'] || {};
				if (this.coffeeMapping) {
					_data["id"] = cd.id || this.formData.id;
					_data["sku"] = cd.sku || this.formData.sku;
					_data["spec_id"] = this.coffeeMapping["id"];
					_data["spec_sku"] = this.coffeeMapping["sku_id"];
				} else {
					var mapping = this.goodsDtl['coffee_sku_mapping'] || {};
					var keys = Object.keys(mapping);
					var first = keys.length > 0 ? mapping[keys[0]] : {};
					_data["id"] = cd.id || first.id || this.formData.id;
					_data["sku"] = cd.sku || first.sku_id || this.formData.sku;
					_data["spec_id"] = first.id || this.formData.id;
					_data["spec_sku"] = first.sku_id || this.formData.sku;
				}
				_data["add_extra"] = _extra;

				this.$store.dispatch("addShoppingCart", _data).then(() => {
					this.close();
					pageevent.$emit("addCartSuccess", this.goodsInfo);
				});
			},
			/**
			 * 递归收集可见子项（扁平化）：
			 * 仅当父级选中了对应子项时，才包含该子项及其下级
			 */
			_collectVisibleChildren(node, extra, depth) {
				var result = [];
				if (!node._children || node._children.length === 0) return result;
				if (depth === undefined) depth = 1;

				var parentVal = extra[node._idx];
				for (var i = 0; i < node._children.length; i++) {
					var child = node._children[i];
					if (parentVal && parentVal['extra_sku'] === child['code']) {
						child._depth = depth;
						result.push(child);
						var sub = this._collectVisibleChildren(child, extra, depth + 1);
						for (var j = 0; j < sub.length; j++) {
							result.push(sub[j]);
						}
					}
				}
				return result;
			},
		},
		computed: {
			flatList() {
				var cd = this.goodsDtl['customization_data'] || {};
				var list = JSON.parse(JSON.stringify(cd['customizations'] || []));
				list.forEach(function(d) {
					var type = d["display_type"];
					if (type == "text" || type == "band" || type == "picture" || type == "picture_row" || type == "picture_switch") {
						d.components = "type1";
					} else if (type == "checkbox" || type == "bool") {
						d.components = "type2";
					} else if (type == "bar" || type == "number") {
						d.components = "type3";
					}
				});
				return list;
			},
			/**
			 * 构建树形结构：
			 * 顶级项 → children（子项）→ children（孙项）
			 * 例如：浓缩咖啡 → 萃取方式变体 → 浓缩份数
			 * 仅包含父级已选中对应子项的分支
			 */
			renderTree() {
				var list = this.flatList;
				var map = {};
				var result = [];

				// 建立 code → item 映射，设置 _idx
				for (var i = 0; i < list.length; i++) {
					var item = list[i];
					if (item.hide === 1) continue;
					item._idx = i;
					item._children = [];
					map[item['code']] = item;
				}

				// 挂载到父级 children，顶级项进入 result
				for (var j = 0; j < list.length; j++) {
					var child = list[j];
					if (child.hide === 1) continue;

					var parentCode = child['parent_category_code'];
					if (!parentCode) {
						result.push(child);
					} else {
						var parent = map[parentCode];
						if (!parent) continue;
						parent._children.push(child);
					}
				}

				return result;
			},
			/**
			 * 将 renderTree 组织为分组，用于模板渲染：
			 * - 有子级的顶级项 → { parent, children }（children 包含整棵子树）
			 * - 独立项 → { parent, children: [] }
			 * 只保留父级已选中对应子项的分支
			 */
			groupedTree() {
				var tree = this.renderTree;
				var groups = [];

				for (var i = 0; i < tree.length; i++) {
					var item = tree[i];
					var flatChildren = this._collectVisibleChildren(item, this.extra);
					groups.push({
						parent: item,
						children: flatChildren
					});
				}

				return groups;
			},
			visibleIndices() {
				var idx = {};
				var groups = this.groupedTree;
				for (var gi = 0; gi < groups.length; gi++) {
					idx[groups[gi].parent._idx] = true;
					var ch = groups[gi].children;
					for (var ci = 0; ci < ch.length; ci++) {
						idx[ch[ci]._idx] = true;
					}
				}
				return idx;
			},
			coffeeMapping() {
				var item0 = this.extra.find(function(d) {
					return d && d["title"] === "咖啡豆选择";
				}) || {};
				var item1 = this.extra.find(function(d) {
					return d && d["title"] === "杯型";
				}) || {};
				var item2 = this.extra.find(function(d) {
					return d && d["title"] === "温度";
				}) || {};
				var key = [item0["extra_sku"], item1["extra_sku"], item2["attribute"]].filter(function(d) {
					return d;
				}).join("_");
				return (this.goodsDtl['coffee_sku_mapping'] || {})[key];
			},
			goodsOptionText() {
				var textList = [];
				var vis = this.visibleIndices;
				for (var fi = 0; fi < this.extra.length; fi++) {
					if (!vis[fi]) continue;
					var item = this.extra[fi];
					if (!item) continue;
					var items = Array.isArray(item) ? item : [item];
					for (var ai = 0; ai < items.length; ai++) {
						if (items[ai] && items[ai].qty > 0) {
							textList.push(items[ai].name);
						}
					}
				}
				return textList.join("/");
			},
			money() {
				var num = 0;
				var vis = this.visibleIndices;
				var list = this.flatList;
				var extra = this.extra;

				for (var fi = 0; fi < extra.length; fi++) {
					if (!vis[fi]) continue;
					var item = extra[fi];
					if (!item) continue;

					if (Array.isArray(item)) {
						var itemDef = list[fi];

						// 特殊处理：浓缩份数
						if (itemDef && itemDef.name === '浓缩份数' && item.length > 0) {
							var shotItem = itemDef.extra_list && itemDef.extra_list[0];
							if (shotItem) {
								var perShot = Number(shotItem.price) || 0;
								// 从当前 SKU 的 rules 中获取该杯型下的默认份数
								var rules = this.getRules(itemDef);
								var defCount = Number(shotItem.default_count) || 0; // 兜底
								if (rules && rules['group_detail_rules'] && rules['group_detail_rules'].length > 0) {
									var ruleDef = rules['group_detail_rules'][0]['default_count'];
									if (ruleDef !== undefined) {
										defCount = Number(ruleDef);
									}
								}

								var qty = Number(item[0].qty) || 0;

								// 1. 萃取方式差价（精萃/满萃才有）
								if (this.selectedExtractionPrice > 0) {
									num += defCount * 100;
								}

								// 2. 额外加份
								num += perShot * Math.max(0, qty - defCount);

								continue;
							}
						}

						// 其他 type3 选项：普通价格累加
						for (var ai = 0; ai < item.length; ai++) {
							if (item[ai] && item[ai].title != '温度') {
								num += Number(item[ai].price) || 0;
							}
						}
					} else if (item.title && item.title != '温度') {
						num += Number(item.price) || 0;
					}
				}

				// 基础价格
				if (this.coffeeMapping) {
					num += Number(this.coffeeMapping['price']) || 0;
				} else {
					num += Number(this.goodsInfo['price']) || 0;
				}

				return (num * this.formData.qty) / 100;
			},
		},
		watch: {},
		components: {
			type1,
			type2,
			type3,
			stepper,
			selectComponent,
		},
	};
</script>

<style lang="scss" scoped>
	.goods-option-container {
		height: 100%;
		display: flex;
		flex-direction: column;
		padding: 20px 20px 0 20px;
		box-sizing: border-box;

		.goods-option-head {
			border-bottom: 1px solid #f1f1f1;
			display: flex;
			align-items: center;

			.img {
				float: left;
				width: 160px;
				height: 160px;
				font-size: 0;
				position: relative;

				&::after {
					content: "";
					position: absolute;
					top: 50%;
					left: 50%;
					width: 130px;
					height: 130px;
					background: #d8db3c;
					border-radius: 50%;
					transform: translate(-50%, -50%);
					z-index: 1;
				}

				img {
					position: relative;
					object-fit: contain;
					display: block;
					width: 100%;
					height: 100%;
					z-index: 2;
				}
			}

			.right {
				flex: 1;
				height: 160px;
				padding: 30px 0 20px 20px;

				.title {
					font-size: 30px;
				}

				p {
					font-size: 24px;
					margin: 0;
					color: #666;
					transform: scale(0.83);
					transform-origin: left;
				}
			}

			.close-img {
				width: 50px;
				height: 50px;
				display: block;
			}
		}

		.goods-option-main {
			flex: 1;
			overflow: auto;

			.number-row {
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
		}

		.goods-option-foot {
			border-top: 1px solid #f1f1f1;
			display: flex;
			justify-content: space-around;
			padding: 16px 0;

			.left-btn,
			.right-btn {
				height: 80px;
				border-radius: 40px;
				box-sizing: border-box;
				font-size: 28px;
			}

			.left-btn {
				width: 100%;
				background: #fff;
				border: 1px solid #5bad70;
				color: #5bad70;
			}

			.right-btn {
				border: 0;
				width: 100%;
				background: #5bad70;
				color: #fff;
				font-weight: bold;
			}
		}
	}

	.goods-option-group {
		border-left: 4px solid #5bad70;
		margin: 30px 20px;
		padding-left: 16px;
	}

	.goods-option-box {
		padding: 0 20px;
		margin-top: 30px;
		margin-bottom: 30px;
		overflow: hidden;

		::v-deep .title {
			font-size: 30px;
			line-height: 80px;
			height: 80px;
			font-weight: bold;
		}
	}

	.goods-option-child {
		margin-top: 0;
		margin-bottom: 0;
		padding: 0;

		::v-deep .title {
			font-size: 26px;
			color: #666;
		}
	}

	.goods-option-grandchild {
		margin-top: 0;
		margin-bottom: 0;
		padding: 0 0 0 20px;

		::v-deep .title {
			font-size: 24px;
			color: #999;
		}
	}
</style>